import { render, staticRenderFns } from "./PasswordRecoveryPage.vue?vue&type=template&id=52dbd796"
import script from "./PasswordRecoveryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordRecoveryPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports